/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

//관리자
import AdminFlatForm from "./admin/components/includes/AdminFlatForm";
import MainAdmin from "./admin/pages/MainAdmin";
import LoginAdmin from "./admin/pages/members/LoginAdmin";

import Variables from "./admin/pages/environments/Variables";
import AdminTerms from "./admin/pages/environments/AdminTerms";
import AdminInformation from "./admin/pages/environments/AdminInformation";
import CompanyInfo from "./admin/pages/environments/CompanyInfo";

import Boards from "./admin/pages/boards/Boards";

import StaffList from "./admin/pages/members/StaffList";
import StaffDetail from "./admin/pages/members/StaffDetail";
import StaffWorkingList from "./admin/pages/members/StaffWorkingList";
import StaffReportList from "./admin/pages/members/StaffReportList";
import StaffReportDetail from "./admin/pages/members/StaffReportDetail";
import StaffAnnualList from "./admin/pages/members/StaffAnnualList";
import StaffAnnualDetail from "./admin/pages/members/StaffAnnualDetail";
import ExpireStaffList from "./admin/pages/members/ExpireStaffList";
import StaffCallNetworkList from "./admin/pages/members/StaffCallNetworkList";
import StaffCallNetworkDetail from "./admin/pages/members/StaffCallNetworkDetail";

import DeliveryList from "./admin/pages/deliverys/DeliveryList";
import DeliveryDetailAdmin from "./admin/pages/deliverys/DeliveryDetail";
import CustomerList from "./admin/pages/deliverys/CustomerList";
import CustomerDetail from "./admin/pages/deliverys/CustomerDetail";

import DriverList from "./admin/pages/drivers/DriverList";
import DriverDetail from "./admin/pages/drivers/DriverDetail";

/* 기사 */
import Main from "./pages/Main";
import Login from "./pages/members/Login";
import FindID from "./pages/members/FindID";
import FoundIDOK from "./pages/members/FoundIDOK";
import FindPWD from "./pages/members/FindPWD";
import EditPWD from "./pages/members/EditPWD";
import FoundPWDOK from "./pages/members/FoundPWDOK";

import DeliveryState from "./pages/deliverys/DeliveryState";
import DeliveryDetail from "./pages/deliverys/DeliveryDetail";
import DeliveryHistory from "./pages/deliverys/DeliveryHistory";

import MyPage from "./pages/mypages/MyPage";
import MyInfo from "./pages/mypages/MyInfo";
import AppSetting from "./pages/mypages/AppSetting";
import ChangeMobile from "./pages/mypages/ChangeMobile";

import Notice from "./pages/boards/Notice";
import NoticeView from "./pages/boards/NoticeView";
import Question from "./pages/boards/Question";
import QuestionView from "./pages/boards/QuestionView";
import QuestionDetail from "./pages/boards/QuestionDetail";
import Conditions from "./pages/boards/Conditions";
import SalesList from "./admin/pages/deliverys/SalesList";

function App() {
  //관리자메뉴 플랫폼 변수
  const [varMenuType, setMenuType] = useState(false);
  const [varMenuItem, setMenuItem] = useState(false);

  return (
    <Router>
      <Routes>
        {/* 관리페이지들 */}
        <Route
          element={
            <AdminFlatForm
              varMenuType={varMenuType}
              varMenuItem={varMenuItem}
            />
          }
        >
          <Route
            path="/Admin"
            element={
              <MainAdmin setMenuType={setMenuType} setMenuItem={setMenuItem} />
            }
          />
          <Route
            path="/MainAdmin"
            element={
              <MainAdmin setMenuType={setMenuType} setMenuItem={setMenuItem} />
            }
          />

          <Route
            path="/Admin/Variables"
            element={
              <Variables setMenuType={setMenuType} setMenuItem={setMenuItem} />
            }
          />
          <Route
            path="/Admin/AdminTerms/:termMode"
            element={
              <AdminTerms setMenuType={setMenuType} setMenuItem={setMenuItem} />
            }
          />
          <Route
            path="/Admin/AdminInformation"
            element={
              <AdminInformation
                setMenuType={setMenuType}
                setMenuItem={setMenuItem}
              />
            }
          />
          <Route
            path="/Admin/CompanyInfo"
            element={
              <CompanyInfo
                setMenuType={setMenuType}
                setMenuItem={setMenuItem}
              />
            }
          />

          <Route
            path="/Admin/StaffList"
            element={
              <StaffList setMenuType={setMenuType} setMenuItem={setMenuItem} />
            }
          />
          <Route
            path="/Admin/StaffDetail/:mem_idx"
            element={
              <StaffDetail
                setMenuType={setMenuType}
                setMenuItem={setMenuItem}
              />
            }
          />
          <Route
            path="/Admin/StaffWorkingList"
            element={
              <StaffWorkingList
                setMenuType={setMenuType}
                setMenuItem={setMenuItem}
              />
            }
          />
          <Route
            path="/Admin/StaffReportList"
            element={
              <StaffReportList
                setMenuType={setMenuType}
                setMenuItem={setMenuItem}
              />
            }
          />
          <Route
            path="/Admin/StaffReportDetail/:sr_idx"
            element={
              <StaffReportDetail
                setMenuType={setMenuType}
                setMenuItem={setMenuItem}
              />
            }
          />
          <Route
            path="/Admin/StaffAnnualList"
            element={
              <StaffAnnualList
                setMenuType={setMenuType}
                setMenuItem={setMenuItem}
              />
            }
          />
          <Route
            path="/Admin/StaffAnnualDetail/:sa_idx"
            element={
              <StaffAnnualDetail
                setMenuType={setMenuType}
                setMenuItem={setMenuItem}
              />
            }
          />
          <Route
            path="/Admin/ExpireStaffList"
            element={
              <ExpireStaffList
                setMenuType={setMenuType}
                setMenuItem={setMenuItem}
              />
            }
          />

          <Route
            path="/Admin/StaffCallNetworkList"
            element={
              <StaffCallNetworkList
                setMenuType={setMenuType}
                setMenuItem={setMenuItem}
              />
            }
          />
          <Route
            path="/Admin/StaffCallNetworkDetail/:stc_idx"
            element={
              <StaffCallNetworkDetail
                setMenuType={setMenuType}
                setMenuItem={setMenuItem}
              />
            }
          />

          <Route
            path="/Admin/DeliveryList"
            element={
              <DeliveryList
                setMenuType={setMenuType}
                setMenuItem={setMenuItem}
              />
            }
          />
          <Route
            path="/Admin/DeliveryDetail/:dc_idx"
            element={
              <DeliveryDetailAdmin
                setMenuType={setMenuType}
                setMenuItem={setMenuItem}
              />
            }
          />
          <Route
            path="/Admin/CustomerList"
            element={
              <CustomerList
                setMenuType={setMenuType}
                setMenuItem={setMenuItem}
              />
            }
          />
          <Route
            path="/Admin/CustomerDetail/:cs_idx"
            element={
              <CustomerDetail
                setMenuType={setMenuType}
                setMenuItem={setMenuItem}
              />
            }
          />

          <Route
            path="/Admin/SalesList"
            element={
              <SalesList setMenuType={setMenuType} setMenuItem={setMenuItem} />
            }
          />

          <Route
            path="/Admin/DriverList/:drMode"
            element={
              <DriverList setMenuType={setMenuType} setMenuItem={setMenuItem} />
            }
          />
          <Route
            path="/Admin/DriverDetail/:drMode/:dr_idx"
            element={
              <DriverDetail
                setMenuType={setMenuType}
                setMenuItem={setMenuItem}
              />
            }
          />
          <Route
            path="/Admin/Boards/*"
            element={
              <Boards setMenuType={setMenuType} setMenuItem={setMenuItem} />
            }
          />
        </Route>
        <Route
          path="/LoginAdmin"
          element={
            <LoginAdmin setMenuType={setMenuType} setMenuItem={setMenuItem} />
          }
        />

        {/* 기사 */}
        <Route path="/" element={<Main />} />
        <Route path="/Main" element={<Main />} />
        <Route path="/Login" element={<Login />} />
        <Route path="/FindID" element={<FindID />} />
        <Route path="/FoundIDOK" element={<FoundIDOK />} />
        <Route path="/FindPWD" element={<FindPWD />} />
        <Route path="/EditPWD/:backMode" element={<EditPWD />} />
        <Route path="/FoundPWDOK" element={<FoundPWDOK />} />

        <Route path="/DeliveryState" element={<DeliveryState />} />
        <Route path="/DeliveryDetail/:dc_idx" element={<DeliveryDetail />} />
        <Route path="/DeliveryHistory" element={<DeliveryHistory />} />

        <Route path="/MyPage" element={<MyPage />} />
        <Route path="/MyInfo" element={<MyInfo />} />
        <Route path="/AppSetting" element={<AppSetting />} />
        <Route path="/ChangeMobile" element={<ChangeMobile />} />

        <Route path="/Notice" element={<Notice />} />
        <Route path="/NoticeView/:board_idx" element={<NoticeView />} />
        <Route path="/Question" element={<Question />} />
        <Route path="/QuestionDetail" element={<QuestionDetail />} />
        <Route path="/QuestionView/:board_idx" element={<QuestionView />} />
        <Route path="/Conditions/:conMode" element={<Conditions />} />
      </Routes>
    </Router>
  );
}

export default App;
